import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import mapConfigToPayload from '../../utils/map-config-to-payload';
import { AuthPayload, PostAnalyticsEventArgs } from '../../types/event-payload';
import { logger } from '../../config/logging-config';

export const postAnalyticsEvent = async ({
  eventName,
  entryPoint,
  vertical,
  eventParams,
}: PostAnalyticsEventArgs): Promise<unknown> => {
  const coreConfigsString: string | null = localStorage.getItem('configs');

  if (!coreConfigsString) {
    console.error('Core configs not found in localStorage.');
    return;
  }

  const data = JSON.parse(coreConfigsString ?? '{}') as AuthPayload;

  const correlationId = uuidv4();
  const baseUrl = process.env.REACT_APP_ANALYTICS_URL;
  const url = `${baseUrl}/`;

  const payload = mapConfigToPayload({
    rawJson: data,
    eventName,
    vertical,
    entryPoint,
    eventParams,
  });

  try {
    const response = await axios.post(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${data.analytics?.token}`,
        correlationId,
      },
    });

    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      logger.error({
        message: 'Error posting analytics event',
        error,
        context: 'Analytics Service Call',
      });
      throw error;
    }
  }
};
